import React, { Component } from "react";

import ProductVariantSelect from "./ProductVariantSelect";

export default class ProductVariant extends Component {
	render() {
		const variant = this.props.variant;

		return (
			<div className="option_wrapper">
				<div className="option_title">{variant.title}:</div>
				<ProductVariantSelect variant={variant} product={this.props.product} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/product/variants/ProductVariant.js